<template>
  <div class="unbind-page tongxin-layout">
    <h1 class="title-with-underline">解除綁定確認頁</h1>

    <p class="unbind-description">
      請注意，解除會員綁定後，將無法使用進一步服務，原先設定的家人資料將無法再顯示。無法再收到個人化訊息通知。請問您要申請「解除綁定」嗎？
    </p>

    <div class="unbind-nav">
      <TongxinNavigation
        :canProceed="canProceed"
        :backButtonIsVisible="true"
        :nextButtonIsVisible="true"
        :textForNextStep="nextButtonText"
        @back="handleBack"
        @next="handleNext"
      />
    </div>

    <div v-if="isUnbinding" class="loading-overlay">
      <b-spinner style="border-width: 2px" />
    </div>
  </div>
</template>

<script>
import register from '@/apis/liff/v2/register';
import TongxinNavigation from '@/components/web/proj/tongxin/layout/TongxinNavigation.vue'
import liff from "@line/liff";

export default {
  name: 'TongxinUnbind',
  components: {
    TongxinNavigation,
  },
  data() {
    return {
      isUnbinding: false,
      canProceed: false,
      remainingSeconds: 5,
    }
  },
  computed: {
    nextButtonText() {
      return this.canProceed ? '解除綁定' : `解除綁定 (${this.remainingSeconds})`;
    },
  },
  mounted() {
    const interval = setInterval(() => {
      this.remainingSeconds--;
      if (this.remainingSeconds <= 0) {
        clearInterval(interval);
        this.canProceed = true;
      }
    }, 1000);
  },
  methods: {
    handleBack() {
      this.$router.push({ name: 'TongxinSetting' })
    },
    async handleNext() {
      this.isUnbinding = true
      try {
        await register.unbind()

        this.isUnbinding = false

        const result = await this.$swal({
          icon: 'success',
          title: '解除綁定成功',
          confirmButtonText: '關閉'
        })

        if (true === result.value) {
          this.goToLineOfficialAccount()
        }
      } catch (error) {
        console.error('解除綁定失敗:', error)
        this.isUnbinding = false
      }
    },
    goToLineOfficialAccount() {
      const orgCode = this.$route.params.orgCode || this.$route.params.org_code

      if (orgCode) {
        window.location.href = `${process.env.VUE_APP_API_BASE_URL}/${orgCode}/liff/general/redirect-to-oa`
        return
      }

      liff.closeWindow()
    },
  },
}
</script>

<style lang="scss" scoped>
.unbind-page {
  max-width: 600px;
  margin: 0 auto;
  padding: 20px;

  .unbind-description {
    margin-top: 40px;
    font-size: 16px;
    line-height: 1.8;
    color: #333;
  }

  .unbind-nav {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 16px;
  }
}
</style>
